import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { EhaErrorBasedTranslationKeys } from '../models/errors'
import { FetchErrorCodes } from '@e3dc-react/shell/Libs'

const translationKeys: EhaErrorBasedTranslationKeys = {
  26006: 'emobility.vehicle-integration.vehicles.vehicle-already-added',
  26007: 'emobility.vehicle-integration.vehicles.vin-not-found',
  26008: 'emobility.vehicle-integration.vehicles.vehicle-image-not-found',
  26009: 'emobility.vehicle-integration.vehicles.vehicle-not-found',
}

export const getTranslationBasedOnEhaErrorCodes = (errorNumber: FetchErrorCodes | undefined): string => {
  if (errorNumber) return translationKeys[errorNumber]

  return 'emobility.vehicle-integration.vehicles.fetching-failed'
}

export function isE3dcError(error: Error | AuthFetchError): error is AuthFetchError {
  return (error as AuthFetchError).response?.data.errno !== undefined
}
